import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import IconTooltipButton from '../../../../button/IconTooltipButton';
import DialogSyncMarkingData from './DialogSyncMarkingData';
import { useSelector } from 'react-redux';

const ButtonSyncMarkingData = ({ loading, periodicalReport = {} }) => {
  const { periodicalReportId } = useParams();
  const [modal, setModal] = useState(false);

  const permission = useSelector((state) => state?.session?.permissions?.['periodical-report-marking']);

  return (
    <>
      {permission?.['sync-marking'] &&
        periodicalReport.isCurrent &&
        ['open-for-marking'].includes(periodicalReport.status) && (
          <>
            <IconTooltipButton
              id={`sync-marking-data-${periodicalReportId}`}
              disabled={loading}
              title='Sync Marking Data'
              icon='sync'
              color='secondary'
              style={{
                borderRadius: '0.5rem',
                color: '#0091ea',
                backgroundColor: '#99dfff',
                padding: '0.45rem',
                opacity: loading ? 0.5 : 1
              }}
              className='shadow-sm'
              onClick={() => setModal(true)}
            />
            <div className='px-4' />
          </>
        )}
      {modal && <DialogSyncMarkingData open={modal} onClose={() => setModal(false)} />}
    </>
  );
};

export default ButtonSyncMarkingData;
